<div class="container-margin">
  <div class="content">
    <h2>{{ translationService.getCreateCompanyText() }}</h2>
    <div class="container margin-top-40">
      <form [formGroup]="companyForm">
        <div class="form-groups">
          <div class="form-group margin-top-10">
            <div>
              <mat-form-field appearance="outline">
                <mat-label>{{
                  translationService.getCompanyNameText()
                }}</mat-label>
                <input
                  matInput
                  type="text"
                  name="name"
                  formControlName="name"
                  autocomplete="off"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="form-group margin-top-10">
            <div>
              <mat-form-field appearance="outline">
                <mat-label>{{
                  translationService.getCompanyIdentificationText()
                }}</mat-label>
                <input
                  matInput
                  type="text"
                  name="identification"
                  formControlName="identification"
                  autocomplete="off"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="form-group margin-top-10">
            <div>
              <mat-form-field appearance="outline">
                <mat-label>{{
                  translationService.getEmailAddressText()
                }}</mat-label>
                <input
                  matInput
                  type="text"
                  name="email"
                  formControlName="email"
                  autocomplete="off"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="form-group margin-top-10">
            <div>
              <mat-form-field appearance="outline">
                <mat-label>{{
                  translationService.getPhoneNumberText()
                }}</mat-label>
                <input
                  matInput
                  type="text"
                  name="phone_number"
                  formControlName="phone_number"
                  autocomplete="off"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="form-groups">
          <div class="form-group margin-top-10">
            <div>
              <mat-form-field appearance="outline">
                <mat-label>{{
                  translationService.getGlobalLocationNumberText()
                }}</mat-label>
                <input
                  matInput
                  type="text"
                  name="global_location_number"
                  formControlName="global_location_number"
                  autocomplete="off"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="form-group margin-top-10">
            <div>
              <mat-form-field appearance="outline">
                <mat-label>{{
                  translationService.getDataUniversalNumberingSystemText()
                }}</mat-label>
                <input
                  matInput
                  type="text"
                  name="data_universal_numbering_system"
                  formControlName="data_universal_numbering_system"
                  autocomplete="off"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="form-group margin-top-10">
            <div>
              <mat-form-field appearance="outline">
                <mat-label>{{
                  translationService.getLegalEntityIdentifierText()
                }}</mat-label>
                <input
                  matInput
                  type="text"
                  name="legal_entity_identifier"
                  formControlName="legal_entity_identifier"
                  autocomplete="off"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="form-groups">
          <div class="form-group margin-top-10">
            <div>
              <mat-form-field appearance="outline">
                <mat-label>{{ translationService.getCountryText() }}</mat-label>
                <mat-select
                  (selectionChange)="handleCountryChange($event)"
                  formControlName="country"
                >
                  @for (country of countries; track country) {
                    <mat-option [value]="country">{{
                      country.name
                    }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="form-group margin-top-10">
            <div>
              <mat-form-field appearance="outline">
                <mat-label>{{ translationService.getStateText() }}</mat-label>
                <mat-select
                  (selectionChange)="handleStateChange($event)"
                  formControlName="state"
                >
                  @for (state of states; track state) {
                    <mat-option [value]="state">{{ state.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="form-group margin-top-10">
            <div>
              <mat-form-field appearance="outline">
                <mat-label>{{ translationService.getCityText() }}</mat-label>
                <mat-select formControlName="city">
                  @for (city of cities; track city) {
                    <mat-option [value]="city">{{ city.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="actions margin-top-10">
          <button
            type="button"
            mat-stroked-button
            extended
            color="primary"
            class="action-item"
            (click)="onReset()"
          >
            <mat-icon>refresh</mat-icon>
            {{ translationService.getResetText() }}
          </button>
          <button
            mat-raised-button
            extended
            color="primary"
            class="action-item"
            (click)="onSubmit()"
          >
            <mat-icon>add</mat-icon>
            {{ translationService.getSubmitText() }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
